import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; 
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms'; 
import { TranslationSettings } from './translation-settings'; 
import { TranslationDTO, TranslatedStringDTO, LabelDTO, TranslationsPostRequestParams, TranslationsSuggestLanguageCodeTextGetRequestParams, TranslationsPutRequestParams, TranslationsIdGetRequestParams, TranslationsService } from 'dev-corize-api-client'; 
import { CorizeBaseComponent } from '../../models/base-corize-component';
import { ToastService } from '../../services/toastr-service'; 
import { Guid } from 'guid-typescript';  
import { CorizeEnvironment } from '../../models/corize-environment';
// @dynamic
@Component({
  selector: 'app-language-translation',
  templateUrl: './language-translation.component.html',
  styleUrls: ['./language-translation.component.css']
})
export class LanguageTranslationComponent extends CorizeBaseComponent implements OnInit {
  
  public form: FormGroup; 
  public settings : TranslationSettings;
  public text : string;
  public edit: boolean = false;
  get f() { return this.form.controls; }
  get ln() { return this.f.languages as FormArray; }
  tag: any;
  constructor(protected toast : ToastService, protected corize:CorizeEnvironment,
    public dialog: MatDialogRef<LanguageTranslationComponent>,  public fb: FormBuilder, protected translationsService: TranslationsService, 
    @Inject(MAT_DIALOG_DATA) public data: [TranslationSettings, string]) {
    super();
  }

  ngOnInit() {
    this.settings = this.data[0];
    this.text = this.data[1];
    
    this.edit = this.settings.translationId != Guid.EMPTY;

    if (!this.edit) {
      this.settings.translationId = Guid.create().toString();
    }


    if (!this.edit) {
      var lang: { [key: string]: string } = {};
      this.settings.languages.forEach(d =>
        lang[d.code] = ""
      );
      var dt: TranslationDTO = {
        id: this.settings.translationId,
        translatedStrings: lang
      }
      this.createForm(dt)
    }
    else {
      this.getTranslations(this.settings.translationId);
    } 
  }

  createForm(data: TranslationDTO) {
    var t = this;
    
    this.form = this.fb.group({
      id: new FormControl({ value: t.settings.translationId, disabled: true }, Validators.required),      
      languages: t.createLanguages(data)
    });

    t.loading = false;
  }


  updateForm(data: TranslationDTO) {
    this.ln.controls.forEach(c => {
      var value = c.value.text;
      var sug = data.translatedStrings[c.value.id];
      if (value == "") {
        var t : any = c;
        t.controls.text.setValue(sug);
      }
    })
  }


  createLanguages(data: TranslationDTO): FormArray {

    var g: FormArray = new FormArray([]);    
    var def = data.translatedStrings[this.settings.defaultLanguage];
    g.push(this.fb.group(
      { 
        id: [ this.settings.defaultLanguage , Validators.required], 
      text: [ def !== this.text ? this.text : def ,  [Validators.required] ] })
    )

    this.settings.languages.filter(e => e.code != this.settings.defaultLanguage).forEach(d => {
      var translated = data.translatedStrings[d.code];
      g.push(this.fb.group({
        id: [d.code , Validators.required],
        text: [ translated,this.settings.requireAll ? [Validators.required] : []]       
      }))
    })
    return g;
  }

  saveTranslations() {
    if (this.edit) {
      this.updateTranslation();
    }
    else {
      this.createTranslation();
    }
  }

  createTranslation() {
    var t = this;
    t.loading = true;

    var item: { [key: string]: string } = {};
    this.ln.controls.forEach(t => {
      item[t.value.id] = t.value.text;
    });

    var trans: TranslationDTO = {
      id: this.settings.translationId,
      translatedStrings: item
    }

    var req: TranslationsPostRequestParams = { 
      translationDTO: trans
    }

    t.translationsService.translationsPost(req).subscribe(
      (ret: TranslationDTO) => {
         
        t.createForm(ret);
        t.loading = false;

        var r: LabelDTO = {
          id : ret.id,
          textInCurrentLanguage  : ret.translatedStrings[this.settings.defaultLanguage]
        } 
         t.dialog.close(r); 
      },
      (err) => { 

        t.loading = false;
        t.toast.showError(err);
      },
      () => {

      });
  }

  getSuggestion() {
    var t = this;    
    var sourceText = this.ln.controls[0].value.text; //.filter(d => d.value.name == this.settings.defaultLanguage)[0].value.text;

    var req: TranslationsSuggestLanguageCodeTextGetRequestParams = { 
      languageCode: this.settings.defaultLanguage,
      text: sourceText
    };

    t.loading = true;
    t.translationsService.translationsSuggestLanguageCodeTextGet(req).subscribe(
      (ret: Array<TranslatedStringDTO>) => {
        var item: { [key: string]: string } = {};        
        ret.forEach(r => {
          item[r.languageCode] = r.text;
        })

        var trans: TranslationDTO = {
          id: this.settings.translationId,
          translatedStrings: item
        }
        t.updateForm(trans)
        t.loading = false;
      },
      (err) => {        
        t.loading = false;
        t.toast.showError(err);
      },
      () => {

      });
  }

  updateTranslation() {
    var t = this;
    t.loading = true;

    var item: { [key: string]: string } = {};
    this.ln.controls.forEach(t => {
      item[t.value.id] = t.value.text;
    });

    var trans: TranslationDTO = {
      id: this.settings.translationId,
      translatedStrings: item
    }

    var req: TranslationsPutRequestParams = {  
      translationDTO: trans
    }
 
    t.translationsService.translationsPut(req).subscribe(
      (ret: TranslationDTO) => {        
        t.createForm(ret);
        t.loading = false;

        var r: LabelDTO = {
          id : ret.id,
          textInCurrentLanguage  : ret.translatedStrings[this.settings.defaultLanguage]
        }
 
        t.dialog.close(r);
      },
      (err) => { 
        t.loading = false;
        t.toast.showError(err);
      },
      () => {

      });
  }

  getTranslations(id: string) {
    var t = this;
    t.loading = true;    
    var req: TranslationsIdGetRequestParams = { 
      id: id
    }

    t.translationsService.translationsIdGet(req).subscribe(
      (ret: TranslationDTO) => {        
        t.createForm(ret);
        t.loading = false;
      },
      (err) => {        
        t.loading = false;
        t.toast.showError(err);
      },
      () => {

      });

  }

}
